"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StatusLabelAppearance = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["appearance", "children", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var StatusLabelAppearance = {
  CAUTION: "caution",
  DEFAULT: "",
  INFORMATION: "information",
  NEGATIVE: "negative",
  POSITIVE: "positive"
};
/**
 * The type of the StatusLabel props.
 */

exports.StatusLabelAppearance = StatusLabelAppearance;

/**
 * A component for the Vanilla Label.
 */
var StatusLabel = function StatusLabel(_ref) {
  var appearance = _ref.appearance,
      children = _ref.children,
      className = _ref.className,
      labelProps = _objectWithoutProperties(_ref, _excluded);

  var classes = (0, _classnames.default)(appearance ? "p-status-label--".concat(appearance) : "p-status-label", className);
  return /*#__PURE__*/_react.default.createElement("div", _extends({}, labelProps, {
    className: classes
  }), children);
};

var _default = StatusLabel;
exports.default = _default;